@if (showUnsavedChangesWarning) {
  <div>
    <mat-card class="error block">
      <mat-card-title>{{saveWarning}}</mat-card-title>
    </mat-card>
  </div>
}
<div class="banner">
  <div class="header rightDivider"><ng-content select="[header]"></ng-content></div>
  <div class="mainControls buttonSet">
    <ng-content select="[buttonsInFront]"></ng-content>
    @if (isSaveEnable) {
      <button class="btn-medium-primary" style="min-width: 100px;" id="saveButton"
      [disabled]="(isModified && isValid)? false : true" (click)="onSave()">{{saveLabel}}</button>
    }
    <ng-content select="[buttonsInMiddle]"></ng-content>
    @if (showUnsavedChangesWarning) {
      <button class="btn-medium-secondary" (click)="closeWithoutSave()"
        data-proceed-without-saving
        label="Proceed without saving">{{proceedButtonLabel}}
      </button>
    }
    @if (!showUnsavedChangesWarning) {
      <button id="cancelButton" class="btn-medium-secondary" style="width: 100px;"
        (click)="onCancel()" label="Cancel">Close
      </button>
    }
    <ng-content select="[buttonsInEnd]"></ng-content>
  </div>

  <div class="expandControls">
    @if ((ies.expandedPanels?.length ?? 0) < (ies.maxPanels ?? 0)) {
      @if (showExpandControls) {
        <a id="expandAllActive" (click)="accordian.openAll(); ies.expandedPanels.length = ies.maxPanels ?? 0">Expand All</a>
      }
    } @else {
      @if (showExpandControls) {
        <span id="expandAllInactive">Expand All</span>
      }
    }
    @if (showExpandControls) {
      <span style="color: #FFFFFF; padding: 0 5px;">/</span>
    }
    @if ((ies.expandedPanels?.length ?? 0) > 0) {
      @if (showExpandControls) {
        <a id="collapseAllActive" (click)="accordian.closeAll(); ies.expandedPanels.length = 0">Collapse All</a>
      }
    } @else {
      @if (showExpandControls) {
        <span id="collapseAllInactive">Collapse All</span>
      }
    }
    <a class="right controls" style="margin-left: 10px;"><span title="Cancel" (click)="onCancel()"><i class="material-icons clear" style="color: #FFFFFF; line-height:36px;">clear</i></span></a>
  </div>
  <br class="clear"/>
</div>
